import { createApp } from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import vuetify from './plugins/vuetify'
import { Amplify } from 'aws-amplify'
import { signOut } from "aws-amplify/auth";
import Cognito from "./Configurations/cognito";
import getGraphQLConfig from "./Configurations/graphql";
import getStorageConfig from "./Configurations/storage";
import { getAmplifyEventsApiConfig } from "./Configurations/portalMaintenanceEvents";
import disableDevtool from "disable-devtool";

disableDevtool({
  disableMenu: false,
  clearLog: true,
  disableConsole: true,
  disableCopy:false,
  disableCut: false,
  disablePaste: false,
  disableInspect: true,
  ondevtoolopen: () => {
    window.location.replace("https://portal.rcshealth.io/");
  },
});

try {
  const portalMaintenanceEventsApi = getAmplifyEventsApiConfig();
  Amplify.configure({
    Auth: {
      Cognito:Cognito(),
      // Cognito: {
      //   userPoolId: 'us-east-1_rnovoqFW0',
      //   userPoolClientId: '6aaf4gjdjkte2ripsksctimeb2',
      //   // signUpVerificationMethod: 'code',
      //   multifactor: {
      //     mode: 'OPTIONAL',
      //     totp: true,
      //     email: true
      //   },
      //   identityPoolId: 'us-east-1:13552369-8ebf-4138-8e46-5b318be12f15' // Replace with your actual Identity Pool ID
      // }
    },

    API: {
        GraphQL:  getGraphQLConfig(),
        ...(portalMaintenanceEventsApi
          ? { Events: portalMaintenanceEventsApi }
          : {}),
    },

    Storage: {
      // S3: {
      //   bucket: 'rx-audit-test',
      //   region: 'us-east-1',
      //   defaultAuthMode: 'userPool'
      // }
      S3:getStorageConfig(),
    }
  })
} catch (error) {
  console.error('Amplify configuration error:', error)
}

const isTokenSessionError = (errorMessage = "") =>
  errorMessage.includes("NoValidAuthTokens") ||
  errorMessage.includes("No federated jwt");

const handleGlobalInvalidSession = async () => {
  if (router.currentRoute.value.path === "/") return;
  try {
    await signOut();
  } catch (error) {
    console.error("Global sign out failed:", error);
  } finally {
    router.push("/");
  }
};

window.addEventListener("unhandledrejection", (event) => {
  const message = event?.reason?.message || "";
  if (isTokenSessionError(message)) {
    event.preventDefault();
    handleGlobalInvalidSession();
  }
});

createApp(App).use(store).use(router).use(vuetify).mount('#app')
